import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
//import Dropdown from 'react-bootstrap/Dropdown';
// import NavLink from 'react-bootstrap/NavLink';
// import NavItem from 'react-bootstrap/NavItem';
export default function Menu(props){
    return(
        <Navbar expand="lg">
            <Navbar.Toggle />
            <Navbar.Collapse>
            <Nav expand="lg">
                {/* <Dropdown as={NavItem}>
                    <Dropdown.Toggle as={NavLink}>معرفی</Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item>Hello there!</Dropdown.Item>
                        <Dropdown.Item>Hello there!</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown> */}
                <Nav.Item>
                    <Nav.Link href="/about">معرفی</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href="/">امکانات</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href="/price">تعرفه ها</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href="/">وبلاگ</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href="/">تماس با ما</Nav.Link>
                </Nav.Item>
            </Nav>
            </Navbar.Collapse>
        </Navbar>
    )
}